export const protectedRoutes = [
  'dashboard',
  'apps',
  'Create Survey',
  'Submission Survey',
  'SU1',
  'SU2',
  'update SU2',
  'SU2 Surveys',
  'SU1 Surveys',
  'Survey Infos',
  'User Operations',
  'Reports',
  'Generate Sections',
  'Surveys For Approval',
  'Company',
  'My Companies',
  'Su1 Results',
  'Su2 Results',
  'Sector',
  'Category',
  'Target',
  'Target Area',
  'KPI',
  'Element',
  'Metric KPI',
  'Sub Metric KPI',
  'Project Search Engine',
  'Global Goals',
  'Sub Goals',
  'Green Deal',
  'KPIs & Metrics',
  'Prompts',
  'Documentation',
  'Supplier Metrics',
  'Admin Panel',
];

export const starterNotAllowed = [
  'Generate Sections',
  'Reports',
  'KPIS & Metrics',
  'KPI Monitoring',
];

export const enterpriseOnly = [
  'KPIs & Metrics',
  'Generate Sections'
];

export const adminOnly = [
  'Sector',
  'Category',
  'Target', 
  'Target Area', 
  'KPI',
  'Element',
  'MetricKPI',
  'SubMetricKPI',
  'GlobalGoals',
  'SubGoals',
  'GreenDeals',
  'Prompts',
  'Additional Settings',
  'Company Facilities Admin',
  'Additional Settings',
  'Prompts',
  'App State',
];

export const auditorOnly = [
  'Audited Companies',
  'Audit Metrics',
  'Audit SDG Alignment',
  'Audit Materiality Analysis',
  'Audit Reports',
  'Audited Company Profile',
];
